import type EstimateValues from "../types/params"
import getDisabledCondition from "./getDisabledCondition"
import getDisplayCondition from "./getDisplayCondition"

const filterEnableValues = (values: EstimateValues) => {
  const isDisplayed = getDisplayCondition(values)
  const idDisabled = getDisabledCondition(values)
  const obj: { [Key in keyof EstimateValues]: EstimateValues[Key] | null } = { ...values }

  for (const key of Object.keys(values) as (keyof EstimateValues)[]) {
    if (!isDisplayed[key] || idDisabled[key]) {
      obj[key] = null
    }
  }

  return obj
}
export default filterEnableValues
